import type {ReactElement} from "react";
import {Chip, type ChipProps} from "@mui/material";
import type {VerificationStatus} from "~/pages/supplier-360/types/Supplier360Types";

/** `VERIFICATION_CHIP[verification_status]` — evidence verification (§2.9) with the design's copy and tones (`SXC_VERIF_TONE`). */
export const VERIFICATION_CHIP: Record<VerificationStatus, ReactElement<ChipProps>> = {
    verified: <Chip size="small" color="success" label="Verified"/>,
    self_attested: <Chip size="small" color="info" label="Self-attested"/>,
    pending: <Chip size="small" color="warning" label="Pending check"/>,
};
